import React, { useState } from "react";
import { Button, Box, Typography, FormLabel } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/styles";
const Uploader = styled(Box)({
  width: "100%",
  padding: "1rem",
  borderRadius: "15px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: 2,
});
const VideoUploader = ({
  title,
  onChange,
  required = false,
}: {
  required?: boolean;
  title?: string;
  onChange?: (file: File | null) => void;
}) => {
  const [selectedVideo, setSelectedVideo] = useState<File | null>(null);
  const handleVideoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setSelectedVideo(event.target.files[0]);
      if (onChange) onChange(event.target.files[0]);
    }
  };

  const handleVideoRemove = () => {
    setSelectedVideo(null);
  };

  return (
    <Uploader bgcolor={"primary.main"} mb={3}>
      <FormLabel
        required={required}
        sx={{
          width: "100%",
          textAlign: "right",
          color: "divider",
          fontSize: "1.2rem",
          fontFamily: "'YekanBold !important'",
          "& .MuiFormLabel-asterisk": { color: "red" },
        }}
      >
        {title}
      </FormLabel>
      <label htmlFor="video-upload">
        <input
          id="video-upload"
          type="file"
          accept="video/*"
          style={{ display: "none" }}
          onChange={handleVideoUpload}
        />
        {!selectedVideo && (
          <img
            alt="upload"
            src={require("../../assets/images/video uploader.png")}
            style={{
              width: "6rem",
              minWidth: "6rem",
              maxWidth: "6rem",
              cursor: "pointer",
            }}
          />
        )}
      </label>
      {selectedVideo && (
        <Box position="relative">
          <Box display="flex" alignItems="center" gap={1}>
            icon
            <Typography variant="body1">{selectedVideo.name}</Typography>
          </Box>
          <Button
            variant="contained"
            color="error"
            size="small"
            startIcon={<CloseIcon />}
            onClick={handleVideoRemove}
            style={{
              position: "absolute",
              top: "8px",
              right: "8px",
            }}
          >
            Remove
          </Button>
        </Box>
      )}
    </Uploader>
  );
};

export default VideoUploader;
